import React from 'react';
import PropTypes from 'prop-types';

import styles from './PromoPriceYearly.scss';
import {__t} from "../lang/text-resource";

const PromoPriceYearly = ({
							  oldPrice,
							  newPrice,
							  yearlyPrice,
							  yearlyOldPrice,
							  currency,
							  mode,
							  term,
							  removeZerosFromNewPrice
						  }) => {

	const currencyMap = {
		BGN: __t('лв'),
		EUR: __t('евро')
	};

	let oldPriceFMT = '';
	let newPriceFMT = '';
	let yearlyPriceFMT = '';
	let yearlyOldPriceFMT = '';
	if (removeZerosFromNewPrice) {
		yearlyPrice = yearlyPrice.replace('.00', '');
	}
	yearlyOldPrice = yearlyOldPrice.replace('.00', '');

	oldPriceFMT =
	  <span>
				<span>{oldPrice}</span> <span dangerouslySetInnerHTML={{__html: currencyMap[currency]}}/>
			</span>;
	newPriceFMT =
	  <span>
				<span>{newPrice}</span> <span dangerouslySetInnerHTML={{__html: currencyMap[currency]}}/>
			</span>;
	yearlyPriceFMT =
	  <span>
				<span>{yearlyPrice}</span> <span dangerouslySetInnerHTML={{__html: currencyMap[currency]}}/>
			</span>;
	yearlyOldPriceFMT =
	  <span>
				<span>{yearlyOldPrice}</span> <span dangerouslySetInnerHTML={{__html: currencyMap[currency]}}/>
			</span>;

	if (mode === 'yearly_only') {
		return (
		  <div className={styles.priceContainer}>
			  <div className={styles.newPrice}>
				  {yearlyPriceFMT}/{term}
			  </div>
			  <div>
					<span className={styles.oldPrice}>
						{yearlyOldPriceFMT}/{term}
					</span>
			  </div>
		  </div>
		);
	}

	return (
	  <div className={styles.priceContainer}>
		  {
			  (oldPrice > 0 && newPrice !== oldPrice) ?
				<div>
						<span data-layout={'padding-right--smm'}>
							{newPriceFMT}/{__t('мес.')}
						</span>
					<span className={styles.oldPrice}>
							{oldPriceFMT}/{__t('мес.*')}
						</span>
				</div>
				:
				null
		  }
		  <div className={styles.newPrice}>
			  {yearlyPriceFMT}/1 {__t('година')}
		  </div>
	  </div>
	);
};
PromoPriceYearly.defaultProps = {
	oldPrice: null,
	mode: 'default',
	yearlyOldPrice: '0.00',
	removeZerosFromNewPrice: true
};

//
PromoPriceYearly.propTypes = {
	newPrice: PropTypes.string.isRequired,
	oldPrice: PropTypes.string.isRequired,
	yearlyPrice: PropTypes.string.isRequired,
	yearlyOldPrice: PropTypes.string,
	currency: PropTypes.string,
	mode: PropTypes.string,
	term: PropTypes.string,
	removeZerosFromNewPrice: PropTypes.bool
};

export default PromoPriceYearly;
